import i18next, { type BackendModule } from 'i18next';
import { initReactI18next } from 'react-i18next';

export const getCurrentHost = window.location.origin;

const CustomBackend: BackendModule = {
  type: 'backend',
  init: (_services, _backendOptions, _i18nextOptions) => {
    /* Use services and options */
  },
  read: async (language, _namespace, callback) => {
    /* Fetch translations from current locales folder of the host */
    // Temporary hide until translation files splitting
    // fetch(`${getCurrentHost}/locales/${language}/${namespace}.json`)
    await fetch(`${getCurrentHost}/locales/${language}/translation.json`)
      .then((response) => response.json())
      .then((data) => {
        callback(null, data);
        // Temporary hide until translation files splitting
        // loadAdditionalTranslations(language, callback);
      })
      .catch((error) => {
        callback(error, null);
      });
  },
  readMulti: async (_languages, _namespaces, callback) => {
    /* Not implemented for CDN loading, can be used for bundling */
    await callback(null, {});
  },
  // save: (language, namespace, data) => {
  //   /* Store the translations, not used for CDN loading */
  // },
  // create: (languages, namespace, key, fallbackValue) => {
  //   /* Save the missing translation, not used for CDN loading */
  // },
};

// Temporary hide until translation files splitting
// Function to load additional translations
// function loadAdditionalTranslations(language, callback) {
//   const additionalLoadPath = `${getCurrentHost}/locales/${language}/translation.json`;

//   fetch(additionalLoadPath)
//     .then((response) => {
//       if (response.ok) {
//         return response.json();
//       } else {
//         throw new Error(`Failed to load '${additionalLoadPath}'`);
//       }
//     })
//     .then((additionalTranslations) => {
//       callback(null, additionalTranslations);
//     })
//     .catch((error) => {
//       callback(error, null);
//     });
// }

export const changeLanguageAndRoute = async (lng: string) => {
  await i18next.changeLanguage(lng, (_error) => {
    // console.log('[i18next]:', { lng, error });
  });
};

i18next
  .use(CustomBackend)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem('i18nextLng') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React handles escaping
    },
    react: {
      useSuspense: false, // Disable suspense mode
    },
  });

export default i18next;
